import { AdjustDateDialog } from "@/components/Dialogs/AdjustTimeDialog"
import { InputDialog } from "@/components/Dialogs/InputDialog"
import { replaceDialog, resetDialogs } from "../dialogs-state"
import { ProjectItem } from "./projects-service"
import { projectAtom, syncProject, updateCurrentProject } from "./projects-state"
import { store } from "../store"
import { LoadingDialog } from "@/components/Dialogs/LoadingDialog"
// eslint-disable-next-line no-restricted-imports -- Phase 1: store-layer i18n
import i18n from "@/i18n"

export const updateProject = async (project: ProjectItem, mutations: Partial<ProjectItem>) => {
	const currentProject = store.get(projectAtom)
	if (currentProject?.id === project.id) {
		await updateCurrentProject(mutations)
	} else {
		await syncProject(project.id, mutations)
	}
}

export const showRenameProjectDialog = (project: ProjectItem) => {
	replaceDialog(InputDialog, {
		title: i18n.t("store:updateProject.renameProjectTitle"),
		buttonTitle: "Rename",
		initialInput: project.name,
		trackingViewName: "rename_project_dialog",
		confirmWithEnter: true,
		onConfirm: async (name) => {
			replaceDialog(LoadingDialog, { title: i18n.t("store:updateProject.updatingProject") })
			try {
				await updateProject(project, { name })
			} finally {
				resetDialogs()
			}
		},
	})
}

export const showChangeProjectDateDialog = (project: ProjectItem) => {
	replaceDialog(AdjustDateDialog, {
		currentDate: project.eventStartedAt,
		handler: async (offset) => {
			replaceDialog(LoadingDialog, { title: i18n.t("store:updateProject.updatingProject") })
			try {
				await updateProject(project, {
					eventStartedAt: new Date(project.eventStartedAt.getTime() + offset),
				})
			} finally {
				resetDialogs()
			}
		},
	})
}
